import {Injectable} from '@angular/core';
import {isNullOrUndefined} from 'util';

@Injectable()
export class PhoneNumberService {

  static readonly nonPhoneNumber = new RegExp('[^0123456789#*]', 'g');
  static readonly longDistanceLandLineFullNumber = new RegExp('^(55|0|00|0[1-9]{2}|00[1-9]{2})?([1-9]{2})([2-6][0-9]{3})([0-9]{4})$');
  static readonly longDistanceMobileFullNumber = new RegExp('^(55|0|00|0[1-9]{2}|00[1-9]{2})?([1-9]{2})(9[0-9]{4})([0-9]{4})$');
  static readonly localMobileNumber = new RegExp('^(9[0-9]{4})([0-9]{4})$');
  static readonly localLandLineNumber = new RegExp('^([2-6][0-9]{3})([0-9]{4})$');
  static readonly tollFreeNumber = new RegExp('^(0)?(0800)([0-9]{3})([0-9]{4})$');
  static readonly fixedRateNumber = new RegExp('^(0)?(0300)([0-9]{3})([0-9]{4})$');

  static parse(n: string, sourceNumber?: PhoneNumber): PhoneNumber {
    // console.log(`Trying to parse ${n} to source ${JSON.stringify(sourceNumber)}`);
    if (isNullOrUndefined(n)) {
      console.warn(`Unable to parse ${n} to PhoneNumber`);
      return null;
    }
    const replacedNumber = this.stripNonPhoneNumberDigits(n);

    let match;

    match = this.tollFreeNumber.exec(replacedNumber);
    if (!isNullOrUndefined(match)) {
      return new PhoneNumber('55', match[2], match[3], match[4]);
    }

    match = this.fixedRateNumber.exec(replacedNumber);
    if (!isNullOrUndefined(match)) {
      return new PhoneNumber('55', match[2], match[3], match[4]);
    }

    match = this.localMobileNumber.exec(replacedNumber);
    if (!isNullOrUndefined(match)) {
      if (isNullOrUndefined(sourceNumber)) {
        console.warn(`Error trying to parse a local number without a source number!!`);
        return null;
      } else {
        return new PhoneNumber('55', sourceNumber.areaCode, match[1], match[2]);
      }
    }

    match = this.localLandLineNumber.exec(replacedNumber);
    if (!isNullOrUndefined(match)) {
      if (isNullOrUndefined(sourceNumber)) {
        console.warn(`Error trying to parse a local number without a source number!!`);
        return null;
      } else {
        return new PhoneNumber('55', sourceNumber.areaCode, match[1], match[2]);
      }
    }

    match = this.longDistanceLandLineFullNumber.exec(replacedNumber);
    if (!isNullOrUndefined(match)) {
      return new PhoneNumber('55', match[2], match[3], match[4]);
    }

    match = this.longDistanceMobileFullNumber.exec(replacedNumber);
    if (!isNullOrUndefined(match)) {
      return new PhoneNumber('55', match[2], match[3], match[4]);
    }

    return null;
  }

  static stripNonPhoneNumberDigits(phone: string): string {
    if (isNullOrUndefined(phone)) {
      return '';
    }
    return phone.replace(this.nonPhoneNumber, '');
  }

  getBetterFormat(number: PhoneNumber, localAreaCode: string): string {
    if (number.areaCode === localAreaCode) {
      return number.getPrettyLocalFormat();
    } else {
      return number.getPrettyLDFormat();
    }
  }

  constructor() {
  }
}


export class PhoneNumber {

  static fromJSON(json: any): PhoneNumber {
    const object: PhoneNumber = Object.create(PhoneNumber.prototype);
    Object.assign(object, json);
    return object;
  }

  constructor(public countryCode: string, public areaCode: string, public prefix: string,
              public extension: string, public description?: string) {
  }

  toString(): string {
    return this.getCleanE164Format();
  }

  getLocalFormat(): string {
    return this.prefix + this.extension;
  }

  getLDFormat(): string {
    return this.areaCode + this.prefix + this.extension;
  }

  getPrettyLocalFormat(): string {
    return this.prefix + '-' + this.extension;
  }

  getPrettyLDFormat(): string {
    return this.areaCode + ' ' + this.prefix + '-' + this.extension;
  }

  getE164Format(): string {
    return this.countryCode + '-' + this.areaCode + '-' + this.prefix + '-' + this.extension;
  }

  getCleanE164Format(): string {
    return this.countryCode + this.areaCode + this.prefix + this.extension;
  }

  getPhoneClass(): string {
    if (this.description.startsWith('extension')) {
      return 'glyphicon glyphicon-earphone';
    } else if (this.description.startsWith('work_land_line')) {
      return 'fa fa-industry';
    } else if (this.description.startsWith('work_mobile')) {
      return 'fa fa-building';
    } else if (this.description.startsWith('home_mobile')) {
      return 'glyphicon glyphicon-home';
    } else if (this.description.startsWith('home_land_line')) {
      return 'glyphicon glyphicon-phone';
    } else {
      return 'fa fa-industry';
    }
  }

  isEqual(p: PhoneNumber): boolean {
    if (this.countryCode === p.countryCode && this.areaCode === p.areaCode && this.prefix === p.prefix && this.extension === p.extension) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/phone-number.service.ts